(ns app.front.view.model-codes.util
  (:require [app.front.util :as futil]
            [app.front.view.model-codes.common :as model-codes-common]
            [re-frame.core-instrumented :as rf]))

(defn add-recent [v item]
  (let [updated-v (->> v
                       (remove #(= % item))
                       (cons item))]
    (take 10 updated-v)))

(rf/reg-event-fx ::store-user-defaults
  (fn [_ [_ group-id book-id content-id]]
    (let [default-books (futil/local-storage-get-json model-codes-common/default-books-local-storage-key)
          recent        (futil/local-storage-get-json model-codes-common/recent-codes-local-storage-key)]
      {:local-storage-set-json! [[model-codes-common/default-books-local-storage-key
                                  (assoc default-books group-id book-id)]
                                 [model-codes-common/recent-codes-local-storage-key
                                  (update-in recent [(str group-id) (str book-id)] #(add-recent % content-id))]]})))

(defn recent-contents [group-id book-id]
  (let [recent (futil/local-storage-get-json model-codes-common/recent-codes-local-storage-key)]
    (-> recent
        (get-in [(str group-id) (str book-id)])
        set)))
